import { ArticleSourceType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import {
  DEFAULT_APPLICATION_BASED_POST_FIELDS,
  DEFAULT_APPLICATION_BASED_QUESTION_FIELDS,
  DEFAULT_APPLICATION_BASED_SUGGESTION_FIELDS,
} from '../constants';
import { useMemo } from 'react';

function useArticleDefaultFields({ articleType }: { articleType: ArticleSourceType }) {
  const defaultArticleFields = useMemo(() => {
    switch (articleType) {
      case ArticleSourceType.POST: {
        return DEFAULT_APPLICATION_BASED_POST_FIELDS;
      }

      case ArticleSourceType.QUESTION: {
        return DEFAULT_APPLICATION_BASED_QUESTION_FIELDS;
      }

      case ArticleSourceType.SUGGESTION: {
        return DEFAULT_APPLICATION_BASED_SUGGESTION_FIELDS;
      }

      default: {
        return DEFAULT_APPLICATION_BASED_POST_FIELDS;
      }
    }
  }, [articleType]);

  return {
    defaultArticleFields,
  };
}

export default useArticleDefaultFields;
